import { useState, forwardRef, useEffect } from 'react';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import './Login.css';
import axios from "axios";
import { useFormik } from 'formik';
import Cookies from 'universal-cookie';
import { useHistory } from 'react-router';
import Navbar from '../../Components/Navbar/Navbar';
const Alert = forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});
const validateLogin = empData => {
  const errors = {};

  if (!empData.Username) {
    errors.Username = 'Campo requerido *';
  }

  if (!empData.Password) {
    errors.Password = 'Campo requerido *';
  }
  return errors;
};

const FormLogin = () => {
  const cookies = new Cookies();
  const history = useHistory();
  const [open, setOpen] = useState(false);
  const [error, setErrorMessage] = useState('');

  useEffect(() => {
    if (cookies.get('tokenCTF')) {
      axios.get(`https://${process.env.REACT_APP_BASE_URL}/api/users/isLogged`, {
        headers: { Authorization: cookies.get('tokenCTF') }
      })
        .then(res => {
          if (res.data.logged === true) {
            history.push('/user');
          }
        })
    }
  }
  );

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };
  const formik = useFormik({
    initialValues: {
      Username: '',
      Password: '',
    },
    validate: validateLogin,
    onSubmit: values => {
      const dataUser = { username: values.Username, password: values.Password };
      axios.post(`https://${process.env.REACT_APP_BASE_URL}/api/login`, dataUser).then((response) => {
        if (response.data.message) {
          setErrorMessage(response.data.message);
          setOpen(true);

        } else {
          setOpen(false);
          setErrorMessage('');
          cookies.set('tokenCTF', response.data.tokenCTF, { path: '/', expires: new Date(Date.now() + 24 * 3600 * 1000) });
          history.push('/user');
        }
      })
    }
  });
  return (
    <>
      <Navbar />
      <div className="login">

        <div className='form-container-login'>

          <div className='form-content-left-login'>
            <img className='form-img-login' src='hacker1.svg' alt='hacker' />
          </div>
          <div className='form-content-right-login'>
            <form className='form-login' onSubmit={formik.handleSubmit}>
              <h1 className="h1login">
                ACCEDER
              </h1>

              <div className='form-inputs-login'>
                <label className='form-label-login'>Usuario</label>
                <input
                  id='Username'
                  name='Username'
                  className='form-input-login'
                  type='text'
                  value={formik.values.Username}
                  placeholder='Ingrese su usuario'
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.Username && formik.errors.Username ? <span className="spanRed">{formik.errors.Username}</span> : null}


              </div>
              <div className='form-inputs-login'>
                <label className='form-label-login'>Contraseña</label>
                <input
                  id='Password'
                  name='Password'
                  className='form-input-login'
                  type='password'
                  value={formik.values.Password}
                  placeholder='Ingrese su contraseña'
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.Password && formik.errors.Password ? <span className="spanRed">{formik.errors.Password}</span> : null}

              </div>

              <button className='form-input-btn-login' type="submit">
                Entrar
              </button>
            </form>
          </div>
        </div>
        <Snackbar open={open} autoHideDuration={3000} onClose={handleClose}>
          <Alert onClose={handleClose} severity="error" className="alertWidth">
            {error}
          </Alert>
        </Snackbar>
      </div>
    </>
  );
};

export default FormLogin;